import { render, staticRenderFns } from "./PharmacyTabLinks.vue?vue&type=template&id=3e55f5cc"
import script from "./PharmacyTabLinks.vue?vue&type=script&lang=js"
export * from "./PharmacyTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports